window.companySelections = {
    mb: {},
    uab: {},
    ii: {},
    idv: {}
};
document.addEventListener('DOMContentLoaded', function() {
    const companySelections = window.companySelections;
    // Helper function to get closest parent element
    function getClosestParent(element, selector) {
        return element.closest(selector);
    }

    // Helper function to serialize form data
    function serializeFormData(form) {
        const formData = new FormData(form);
        const data = [];
        for (let [key, value] of formData.entries()) {
            data.push({ name: key, value: value });
        }
        return data;
    }

    // Helper function to convert array to URL encoded string
    function arrayToFormData(data) {
        const params = new URLSearchParams();
        data.forEach(item => {
            params.append(item.name, item.value);
        });
        return params;
    }

    // Helper function to get data attribute as JSON
    function getDataJson(element, attributeName) {
        const data = element.dataset[attributeName];
        if (!data) return null;
        try {
            return JSON.parse(data);
        } catch (e) {
            return null;
        }
    }


    // Helper function to show/hide elements
    function showElement(element) {
        if (element) {
            element.classList.remove('hide-onload');
        }
    }

    function hideElement(element) {
        if (element) {
            element.classList.add('hide-onload');
        }
    }

    // Info icon button click handler
    const infoIconBtns = document.querySelectorAll('.info-icon-btn');
    infoIconBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            const container = getClosestParent(this, '.tooltip-container');
            if (container) {
                container.classList.toggle('active');
            }
        });
    });

    // Send offer form submission
    const sendOfferForm = document.querySelector('form.send-offer');
    if (sendOfferForm) {
        sendOfferForm.addEventListener('submit', function(e) {
            e.preventDefault();

            const formData = serializeFormData(this);
            const html = document.querySelector('.totals-container').innerHTML;

            // Add security and html to form data
            formData.push({ name: 'security', value: ajax_nonce });
            formData.push({ name: 'html', value: html });

            // Send AJAX request
            fetch(ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: arrayToFormData(formData)
            })
            .then(response => response.text())
            .then(data => {
                alert("Išsiųsta");
                this.querySelector('input[name="email"]').value = '';
                this.querySelector('input[name="phone"]').value = '';
            })
            .catch(error => {
                alert("There was an error: " + error);
            });
        });
    }

    // Disable scroll on number inputs when focused
    const numberInputs = document.querySelectorAll('form input[type=number]');
    numberInputs.forEach(input => {
        input.addEventListener('focus', function() {
            const wheelHandler = (e) => e.preventDefault();
            this.addEventListener('wheel', wheelHandler, { passive: false });
            // Store the handler so we can remove it later
            this._wheelHandler = wheelHandler;
        });

        input.addEventListener('blur', function() {
            if (this._wheelHandler) {
                this.removeEventListener('wheel', this._wheelHandler);
                delete this._wheelHandler;
            }
        });
    });

    // Company type radio buttons handler


    const companyTypeRadios = document.querySelectorAll('.company-type--radio');
    let currentCompany = document.querySelector('.company-type--radio:checked')?.value; // track currently selected

    companyTypeRadios.forEach(radio => {
        radio.addEventListener('change', function() {
            const newCompany = this.value;

            // Save inputs for current company before switching
            if (currentCompany) {
                document.querySelectorAll(`.pricing-block[data-id="${currentCompany}"] input`).forEach(input => {
                    companySelections[currentCompany][input.name] = input.value;
                });

            }

            // Show/hide blocks for new company & restore saved values
            document.querySelectorAll('.pricing-block[data-id]').forEach(el => {
                const input = el.querySelector('input');
                if (el.dataset.id === newCompany) {
                    el.classList.remove('hide');
                    if (input && companySelections[newCompany][input.name] !== undefined) {
                        input.value = companySelections[newCompany][input.name];
                    }
                } else {
                    el.classList.add('hide');
                }
            });

            // Show/hide additional notes
            document.querySelectorAll('.company-type--def-prices > div[data-id]').forEach(note => {
                if (note.dataset.id === newCompany) {
                    note.classList.remove('hide');
                } else {
                    note.classList.add('hide');
                }
            });

            document.querySelectorAll('tr.post-scriptum-text[data-id]').forEach(row => {
                row.dataset.id === newCompany ? row.classList.remove('hide') : row.classList.add('hide');
            });

            // Show/hide annual-jobs
            document.querySelectorAll('ul.annual-jobs[data-id]').forEach(list => {
                list.dataset.id === newCompany ? list.classList.remove('hide') : list.classList.add('hide');
            });
            document.querySelectorAll('.annual-jobs:not(.hide)').forEach(ul => {
                ul.querySelectorAll('li.expanded > .pricing-line-header').forEach(header => {
                    header.classList.add('active'); // mark header as active if li is expanded

                    const instructions = header.nextElementSibling;
                    if (instructions && instructions.classList.contains('instructions')) {
                        instructions.style.display = 'block'; // show instructions on load
                    }

                    // Add click toggle
                    // header.addEventListener('click', function () {
                    //     const instructions = this.nextElementSibling;
                    //     if (instructions && instructions.classList.contains('instructions')) {
                    //         Utils.slideToggle(instructions); // your slide animation
                    //         this.classList.toggle('active');
                    //     }
                    // });
                });
            });

            // Update displayed company type
            const valueElem = document.querySelector('.company-type-value');
            if (valueElem) valueElem.innerHTML = newCompany.toUpperCase();

            // Update tracker
            currentCompany = newCompany;

            // Recalculate totals
            countTotals();
        });
    });


    // Price calculation input handlers
    const priceInputs = document.querySelectorAll('.price-calculation input:not([type="radio"])');
    priceInputs.forEach(input => {
        ['keyup', 'change'].forEach(eventType => {
            input.addEventListener(eventType, function() {
                const pricingBlock = getClosestParent(this, '.pricing-block');
                const inputContainer = getClosestParent(this, '.input-container');

                if (pricingBlock && this.type === 'number') {
                    if (this.value <= 0) {
                        pricingBlock.classList.remove('filled');
                        const minusSign = inputContainer ? inputContainer.querySelector('.minus-sign') : null;
                        if (minusSign) minusSign.classList.add('disabled');
                    } else {
                        pricingBlock.classList.add('filled');
                        const minusSign = inputContainer ? inputContainer.querySelector('.minus-sign') : null;
                        if (minusSign) minusSign.classList.remove('disabled');
                    }
                }
                countTotals();
            });
        });
    });

    // Plus and minus sign handlers
    const plusMinusSigns = document.querySelectorAll('.input-container > .plus-sign, .input-container > .minus-sign');
    plusMinusSigns.forEach(sign => {
        sign.addEventListener('mousedown', function() {
            const pricingBlock = getClosestParent(this, '.pricing-block');
            if (pricingBlock) {
                pricingBlock.classList.add('blink');
                setTimeout(() => {
                    document.querySelectorAll('.pricing-block').forEach(block => {
                        block.classList.remove('blink');
                    });
                }, 100);
            }
        });
    });

    // Plus sign click handler
    const plusSigns = document.querySelectorAll('.input-container > .plus-sign');
    plusSigns.forEach(sign => {
        sign.addEventListener('click', function() {
            const inputContainer = getClosestParent(this, '.input-container');
            const input = inputContainer ? inputContainer.querySelector('input') : null;
            if (input) {
                input.value = parseInt(input.value || 0) + 1;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });

    // Minus sign click handler
    const minusSigns = document.querySelectorAll('.input-container > .minus-sign');
    minusSigns.forEach(sign => {
        sign.addEventListener('click', function() {
            const inputContainer = getClosestParent(this, '.input-container');
            const input = inputContainer ? inputContainer.querySelector('input') : null;
            if (input) {
                const currentValue = parseInt(input.value || 0);
                if (currentValue > 1) {
                    input.value = currentValue - 1;
                } else {
                    input.value = 0;
                }
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });

    const companyTypeRadioElements = document.querySelectorAll('.company-type--radio');
    companyTypeRadioElements.forEach(radio => {
        radio.addEventListener('change', function() {
            const companyType = this.value;

            const valueElem = document.querySelector('.company-type-value');
            if (valueElem) valueElem.innerHTML = companyType ? companyType.toUpperCase() : '';
        })
    });
    function countTotals() {
        const basePriceEl = document.getElementById('base-price');
        let basePrice = getPriceByCompanyType(basePriceEl);
        let gpmPrice = 0;
        let vatPrice = 0;
        let blocksAmount = 0;
        let totalInvoices = 0;

        // Update base price display
        const basePriceDisplay = document.querySelector('.baseprice-count-totals');
        if (basePriceDisplay) {
            basePriceDisplay.innerHTML = basePrice + ' €';
        }

        // Process pricing blocks
        const pricingBlocks = document.querySelectorAll(
            '.price-calculation .pricing-block:not(.vat):not(.company-type):not(.hide)'
        );
        pricingBlocks.forEach(block => {
            const input = block.querySelector('input');
            if (!input) return;

            const priceRules = getDataJson(input, 'prices');
            const flag = input.dataset.specialflag;
            const qty = parseInt(input.value || 0);
            let remainingQty = qty;
            const inputName = input.getAttribute('name');
            let blockAmount = 0;
            // Skip if no price rules defined
            if (!priceRules || !priceRules.length) {
                return;
            }

            if (flag === 'employees') {
                if (qty > 0) {
                    const gpmPriceEl = document.getElementById('gpm-price');
                    gpmPrice = getPriceByCompanyType(gpmPriceEl);
                    const gpmCountTotals = document.querySelector('#totals-container .gpm-info .count-totals');
                    if (gpmCountTotals) {
                        gpmCountTotals.innerHTML = parseFloat(gpmPrice).toFixed(2) + ' €';
                    }
                    showElement(document.querySelector('.gpm-info'));
                } else {
                    const gpmCountTotals = document.querySelector('#totals-container .gpm-info .count-totals');
                    if (gpmCountTotals) {
                        gpmCountTotals.innerHTML = parseFloat(gpmPrice).toFixed(2) + ' €';
                    }
                    hideElement(document.querySelector('.gpm-info'));
                }
            } else if (flag === 'invoices') {
                totalInvoices += qty;
            }

            // Calculate block amount based on price rules
            for (let i = 0; i < priceRules.length && remainingQty > 0; i++) {
                const currentRule = priceRules[i];
                const nextRule = priceRules[i + 1];
                const maxQtyInRange = nextRule ? nextRule.qty - currentRule.qty : remainingQty;
                const qtyInRange = Math.min(remainingQty, maxQtyInRange);

                blockAmount += qtyInRange * parseFloat(currentRule.price);
                remainingQty -= qtyInRange;
            }

            blocksAmount += blockAmount;

            // Update display for this block
            const countEl = document.querySelector(`#totals-container .${inputName}-info .count`);
            if (countEl) countEl.innerHTML = `(${qty})`;

            const countTotalsEl = document.querySelector(`#totals-container .${inputName}-info .count-totals`);
            if (countTotalsEl) countTotalsEl.innerHTML = blockAmount.toFixed(2) + ' €';

            const infoEl = document.querySelector(`#totals-container .${inputName}-info`);
            if (infoEl) {
                if (qty > 0) {
                    showElement(infoEl);
                } else {
                    hideElement(infoEl);
                }
            }
        });

        // VAT calculations
        let vatTotals = 0;
        const vatInvoicesEl = document.getElementById('vat_invoices');
        const priceRules = getVatInvoiceRulesByCompanyType(vatInvoicesEl);
        let remainingQty = totalInvoices;

        if (priceRules && priceRules.length) {
            for (let i = 0; i < priceRules.length && remainingQty > 0; i++) {
                const currentRule = priceRules[i];
                const nextRule = priceRules[i + 1];
                const maxQtyInRange = nextRule ? nextRule.qty - currentRule.qty : remainingQty;
                const qtyInRange = Math.min(remainingQty, maxQtyInRange);

                vatTotals += qtyInRange * parseFloat(currentRule.price);
                remainingQty -= qtyInRange;
            }
        }

        const vatPayeeCheckbox = document.getElementById('vat-payee');
        if (vatPayeeCheckbox && vatPayeeCheckbox.checked) {
            vatPrice = getPriceByCompanyType(vatPayeeCheckbox)
            const vatInvoiceCountTotals = document.querySelector('.vat-invoice-count-totals');
            if (vatInvoiceCountTotals) {
                vatInvoiceCountTotals.innerHTML = parseFloat(vatTotals).toFixed(2) + ' €';
            }
            const vatPayeeCountTotals = document.querySelector('.vat-payee-count-totals');
            if (vatPayeeCountTotals) {
                vatPayeeCountTotals.innerHTML = parseFloat(vatPrice).toFixed(2) + ' €';
            }
            showElement(document.querySelector('.vat-info'));
            showElement(document.querySelector('.vat-invoice-info'));
            const vatBlock = getClosestParent(vatPayeeCheckbox, '.pricing-block');
            if (vatBlock) vatBlock.classList.add('filled');
        } else {
            vatTotals = 0;
            const vatPayeeCountTotals = document.querySelector('.vat-payee-count-totals');
            if (vatPayeeCountTotals) {
                vatPayeeCountTotals.innerHTML = parseFloat(vatPrice).toFixed(2) + ' €';
            }
            const vatInvoiceCountTotals = document.querySelector('.vat-invoice-count-totals');
            if (vatInvoiceCountTotals) {
                vatInvoiceCountTotals.innerHTML = parseFloat(vatTotals).toFixed(2) + ' €';
            }
            hideElement(document.querySelector('.vat-info'));
            hideElement(document.querySelector('.vat-invoice-info'));
            if (vatPayeeCheckbox) {
                const vatBlock = getClosestParent(vatPayeeCheckbox, '.pricing-block');
                if (vatBlock) vatBlock.classList.remove('filled');
            }
        }

        // Calculate total
        const result = basePrice + gpmPrice + vatPrice + vatTotals + blocksAmount;
        const calcTotals = document.getElementById('calc-totals');
        if (calcTotals) {
            calcTotals.innerHTML = result.toFixed(2) + ' €';
        }
    }

    function getPriceByCompanyType(el, prefix = 'price') {
        if (!el) return 0;

        const selectedCompany = document.querySelector('input[name="company-type"]:checked');
        if (!selectedCompany) return 0;

        const type = selectedCompany.value; // uab | mb | ii | idv
        const key = `${prefix}${type.charAt(0).toUpperCase()}${type.slice(1)}`;

        return parseFloat(el.dataset[key] || 0);
    }

    function getVatInvoiceRulesByCompanyType(el) {
        if (!el) return null;

        const selectedCompany = document.querySelector('input[name="company-type"]:checked');
        if (!selectedCompany) return null;

        const type = selectedCompany.value;
        const key = `prices${type.charAt(0).toUpperCase()}${type.slice(1)}`;

        return getDataJson(el, key);
    }

    // Initial calculation
    countTotals();
});


